import { SYSTEM_ERROR } from "../config/CONSTANTS";
import {
  GET_ALL_BILLING_PLAN,
  GET_CURRENT_BILLING_PLAN_STATUS,
  SET_BILLING_PLAN,
  CANCEL_BILLING_PLAN,
  GET_SHOPIFY_PERMISSION_PAGE_URL,
  GET_SHOPIFY_INVENTORY_TRANSFERS_PERMISSION_URL,
  GET_SHOPIFY_AUTHORIZE_LOCATIONS_URL,
} from "./CONSTANTS";
import axiosInstance from "../utils/axiosInstance";

/**
 * Fetch the public billing plan list from GET /api/billingplan.
 * This endpoint does not require a token. A session token is still sent when
 * App Bridge has one so whitelisted shops can receive the discounted plan.
 *
 * Example: getAllBillingPlan()
 *   => { data: [{ id, plan_name, ... }], success: true, ... }
 */

export const getAllBillingPlan = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_ALL_BILLING_PLAN(), { optionalAuth: true })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getAllBillingPlan axios!");
        });
    } catch (error) {
      console.error(
        "in billingPlanServices > getAllBillingPlan, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

export const selectBillingPlan = (selectedBillingPlan) => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(SET_BILLING_PLAN(), selectedBillingPlan)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in selectBillingPlan Axios!");
        });
    } catch (error) {
      console.error(
        "in billingPlanServices > selectBillingPlan, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

/**
 * Cancels the shop's Shopify subscription.
 * POST /api/billingplan/cancel with no body.
 *
 * Example success: { success: true, message: "Subscription cancelled", data: null }
 * Example failure: { success: false, error: [{ code: 400, message: "..." }] }
 */
export const cancelBillingSubscription = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(CANCEL_BILLING_PLAN())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in cancelBillingSubscription Axios!");
        });
    } catch (error) {
      console.error(
        "in billingPlanServices > cancelBillingSubscription, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

export const getCurrentBillingPlan = () => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_CURRENT_BILLING_PLAN_STATUS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getCurrentBillingPlan axios!");
        });
    } catch (error) {
      console.error(
        "in billingPlanServices > getCurrentBillingPlan, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAuthorizeHistoricalOrdersShopifyRedirectLink = (params) => {

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_SHOPIFY_PERMISSION_PAGE_URL(), { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getCurrentBillingPlan axios!");
        });
    } catch (error) {
      console.error(
        "in billingPlanServices > getCurrentBillingPlan, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAuthorizeInventoryTransfersRedirectLink = (shopName) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_SHOPIFY_INVENTORY_TRANSFERS_PERMISSION_URL(), {
          params: { shop: shopName },
        })
        .then((res) => resolve(res.data))
        .catch(() => reject("Error fetching inventory transfers redirect URL"));
    } catch (error) {
      console.error(
        "in billingPlanServices > getAuthorizeInventoryTransfersRedirectLink, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

/**
 * Fetches the Shopify OAuth URL used to re-authorize the read_locations scope.
 * Resolves with the ResponseMapper whose `.data` is the OAuth redirect URL.
 */
export const getAuthorizeLocationsRedirectLink = (shopName) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_SHOPIFY_AUTHORIZE_LOCATIONS_URL(), {
          params: { shop: shopName },
        })
        .then((res) => resolve(res.data))
        .catch(() => reject("Error fetching locations authorization redirect URL"));
    } catch (error) {
      console.error(
        "in billingPlanServices > getAuthorizeLocationsRedirectLink, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};
